import React from 'react';

const HelpModal = ({ onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(255, 255, 255, 0.95)',
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      boxSizing: 'border-box'
    }}>
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '2rem',
          right: '2rem',
          background: 'transparent',
          border: 'none',
          color: '#666',
          fontSize: '2rem',
          cursor: 'pointer',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          transition: 'all 0.2s ease'
        }}
        onMouseOver={(e) => {
          e.target.style.background = '#f0f0f0';
          e.target.style.color = '#333';
        }}
        onMouseOut={(e) => {
          e.target.style.background = 'transparent';
          e.target.style.color = '#666';
        }}
      >
        ×
      </button>

      {/* Help Content */}
      <div style={{
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <h2 style={{
          margin: '0 0 2rem 0',
          color: '#E8A5C4',
          fontSize: '2rem',
          fontFamily: 'Sofia Pro Bold, sans-serif',
          fontWeight: 'normal'
        }}>
          Ayuda
        </h2>
        
        <p style={{
          margin: '0 0 2rem 0',
          color: '#666',
          fontSize: '1.2rem',
          fontFamily: 'Sofia Pro Regular, sans-serif',
          lineHeight: '1.5'
        }}>
          Escaneá la paloma de Dove
        </p>
        
        <div style={{
          margin: '0 0 2rem 0',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <img 
            src="/help_tracker.png" 
            alt="Dove tracker help" 
            style={{
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              console.log('Help tracker image failed to load');
            }}
          />
        </div>
        
        <button 
          onClick={onClose}
          style={{
            background: '#E8A5C4',
            border: 'none',
            color: 'white',
            padding: '1rem 2rem',
            fontSize: '1rem',
            fontFamily: 'Sofia Pro SemiBold, sans-serif',
            fontWeight: 'normal',
            borderRadius: '25px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(232, 165, 196, 0.3)',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#D494B4';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#E8A5C4';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Volver
        </button>
      </div>
    </div>
  );
};

export default HelpModal;
